import { render, staticRenderFns } from "./card-tariff.vue?vue&type=template&id=5b1731bb&"
import script from "./card-tariff.vue?vue&type=script&lang=js&"
export * from "./card-tariff.vue?vue&type=script&lang=js&"
import style0 from "./card-tariff.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports